module.exports = __webpack_public_path__ + "static/media/memory.f39e8ea4.gif";